import { render, staticRenderFns } from "./attenshift.vue?vue&type=template&id=1ae4cb91&scoped=true&"
import script from "./attenshift.vue?vue&type=script&lang=js&"
export * from "./attenshift.vue?vue&type=script&lang=js&"
import style0 from "./attenshift.vue?vue&type=style&index=0&id=1ae4cb91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4cb91",
  null
  
)

export default component.exports